import pipe from "../../lib/core/functional/pipe";

import logoEditLoader from "./logo/loader";
import titleEditLoader from "./title/loader";
import aboutEditLoader from "./about/loader";

const allModuleLoader = pipe(logoEditLoader, titleEditLoader, aboutEditLoader);

export default function loadSiteEdit(context, element) {
    const userProfile = element.closest(".user-profile");
    if (userProfile) {
        userProfile.classList.add("processed");
    }
    allModuleLoader(context);
    return context;
}
